import React from 'react';
import { Building2, Globe, FlaskConical, MapPin } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Market() {
  const {
    t
  } = useLanguage();
  const targetMarkets = [{
    icon: Building2,
    label: t.market.targetMarkets.items[0]
  }, {
    icon: Globe,
    label: t.market.targetMarkets.items[1]
  }, {
    icon: FlaskConical,
    label: t.market.targetMarkets.items[2]
  }];
  const primaryMarkets = [{
    label: t.market.primaryMarkets.domestic.label,
    description: t.market.primaryMarkets.domestic.description
  }, {
    label: t.market.primaryMarkets.international.label,
    description: t.market.primaryMarkets.international.description
  }];
  return <section className="w-full py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-122">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-123">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] border-2 border-emerald-500 rounded-full" data-id="element-124" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] border-2 border-emerald-500 rounded-full" data-id="element-125" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-127">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-128">
            {t.market.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-129">
            {t.market.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-130">
            {t.market.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12" data-id="element-131">
          {/* Target Markets */}
          <div data-id="element-132">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-133">
              <MapPin className="w-5 h-5 text-emerald-600" data-id="element-134" />
              {t.market.targetMarkets.title}
            </h3>
            <div className="space-y-4" data-id="element-135">
              {targetMarkets.map((market, index) => <div key={index} className="flex items-center gap-4 p-5 bg-gray-50 rounded-xl hover:bg-emerald-50 transition-colors" data-id="element-136">
                  <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center" data-id="element-137">
                    <market.icon className="w-6 h-6 text-emerald-700" data-id="element-138" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-139">
                    {market.label}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Primary Markets */}
          <div data-id="element-140">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-141">
              <Globe className="w-5 h-5 text-emerald-600" data-id="element-142" />
              {t.market.primaryMarkets.title}
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-143">
              {primaryMarkets.map((market, index) => <div key={index} className="bg-gradient-to-br from-emerald-700 to-emerald-800 rounded-2xl p-6 text-white text-center" data-id="element-144">
                  <h4 className="text-2xl font-bold mb-2" data-id="element-145">{market.label}</h4>
                  <p className="text-emerald-200 text-sm" data-id="element-146">
                    {market.description}
                  </p>
                </div>)}
            </div>

            {/* World Map Placeholder */}
            <div className="mt-6 bg-emerald-50 rounded-2xl p-8 text-center" data-id="element-147">
              <Globe className="w-16 h-16 text-emerald-300 mx-auto mb-4" data-id="element-148" />
              <p className="text-emerald-700 font-medium" data-id="element-149">
                {t.market.primaryMarkets.serving}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}